import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, SearchButton, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRecoveryList extends Layout {
    buttonBypassBatch: Button;
    buttonClearSearch: Button;
    buttonExpand: Button;
    buttonSearch: SearchButton;
    buttonViewTransmissionLog: Button;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelSearch: Label;
    panelSearch: Panel;
    panelSearchHeader: Panel;
    sourceEdirecoveryList: DataSource;
    switchPartner: Switch;
    tableRecovery: Table;
    textboxAltPartnerId: Textbox;
    textboxBatch: Textbox;
    textboxCreateDate: Textbox;
    textboxDirection: Textbox;
    textboxEdiLogId: Textbox;
    textboxFilename: Textbox;
    textboxId: Textbox;
    textboxMaxResults: Textbox;
    textboxOrigProfileId: Textbox;
    textboxOrigTransType: Textbox;
    textboxPartnerId: Textbox;
    textboxTotalFuncGrps: Textbox;
    textboxTransactionType: Textbox;
    textboxVersion: Textbox;
}
